import api from './axios';

/**
 * Obtiene un token efímero (2 min, single-use) y abre la URL del PDF en nueva pestaña.
 * @param {string} path  - ruta relativa al BASE_URL, sin ?token (e.g. '/api/budgets/3/pdf')
 * @param {Object} params - query params adicionales (lang, currency, style, etc.)
 */
const openPdf = async (path, params = {}) => {
  const { data } = await api.post('/pdf-token');
  const query = new URLSearchParams({ token: data.token, ...params });
  window.open(`${process.env.REACT_APP_BASE_URL}${path}?${query.toString()}`, '_blank');
};

export default openPdf;
